import { Address } from '@models/address';
import { Patient } from '@models/patient';

export class ShippingAddressStoreRequest {
  public first_name: string;
  public last_name: string;
  public street: string;
  public street_2?: string;
  public city: string;
  public state_id: number;
  public zip_code: string;
  public phone_number: string;
  public test_ids?: number[];
  public shipping_service?: string;

  public constructor(address: any, patient: Patient, testIds: number[] = null, shippingService: string = '') {
    this.street = address.streetAddress || address.customer_address_street;
    this.street_2 = address.streetAddress2 || address.customer_address_street2;
    this.city = address.city || address.customer_address_city;
    this.state_id = Address.statesIds[address.state || address.customer_address_state];
    this.zip_code = address.zipcode || address.customer_address_zip;
    this.first_name = patient.name;
    this.last_name = patient.last_name;
    this.phone_number = patient.phone;
    this.test_ids = testIds;

    if (shippingService) {
      this.shipping_service = shippingService;
    }
  }
}
